import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { NavigationOptions } from '@ionic/angular/common/providers/nav-controller';
import { IMSId, IMSObjectType } from 'src/app/_model/ims-object';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { EmployeeService } from '../../employee/logic/employee.service';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';

@Injectable({
  providedIn: 'root',
})
export class ExtDocActionHandler implements ActionHandler {
  public readonly name: ActionHandlerType = 'extdoc';

  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
    private employeeService: EmployeeService,
    private navController: NavController,
    private router: Router
  ) {}

  public async executeAction(params?: any): Promise<any> {
    this.logger.log(this.constructor.name, 'ExtDocActionHandler with params', params);

    const targetRef: IMSObjectType = params?.['targetRef'] ?? 'ims/ServiceJob';
    const targetId = this.loadObjIdForTargetRef(targetRef);
    const hiddenExtFileTypeSysCodes = params?.['hiddenExtFileTypeSysCodes']
    const hiddenExtFileTypeShortNames = params?.['hiddenExtFileTypeShortNames']
    const hiddenExtFileTypeMappingCodes = params?.['hiddenExtFileTypeMappingCodes']
    const shownExtFileTypeSysCodes = params?.['shownExtFileTypeSysCodes']
    const shownExtFileTypeShortNames = params?.['shownExtFileTypeShortNames']
    const shownExtFileTypeMappingCodes = params?.['shownExtFileTypeMappingCodes']
    const selectAllFilters = params?.['selectAllFilters']
    const selectWithinCurrentJobSectionPath = params?.['selectWithinCurrentJobSectionPath']

    const navOptions: NavigationOptions = {
      queryParams: {
        targetRef,
        targetId: JSON.stringify(targetId),
        customBackUrl: this.router.url,
        hiddenExtFileTypeSysCodes: hiddenExtFileTypeSysCodes != undefined ? JSON.stringify(hiddenExtFileTypeSysCodes) : undefined,
        hiddenExtFileTypeShortNames: hiddenExtFileTypeShortNames != undefined ? JSON.stringify(hiddenExtFileTypeShortNames) : undefined,
        hiddenExtFileTypeMappingCodes: hiddenExtFileTypeMappingCodes != undefined ? JSON.stringify(hiddenExtFileTypeMappingCodes) : undefined,
        shownExtFileTypeSysCodes: shownExtFileTypeSysCodes != undefined ? JSON.stringify(shownExtFileTypeSysCodes) : undefined,
        shownExtFileTypeShortNames: shownExtFileTypeShortNames != undefined ? JSON.stringify(shownExtFileTypeShortNames) : undefined,
        shownExtFileTypeMappingCodes: shownExtFileTypeMappingCodes != undefined ? JSON.stringify(shownExtFileTypeMappingCodes) : undefined,
        selectAllFilters: selectAllFilters != undefined ? JSON.stringify(selectAllFilters) : undefined,
        selectWithinCurrentJobSectionPath: selectWithinCurrentJobSectionPath != undefined ? JSON.stringify(selectWithinCurrentJobSectionPath) : undefined,
      },
    };
    this.navController.navigateForward('/feature/extdoc', navOptions);
  }

  private loadObjIdForTargetRef(targetRef: IMSObjectType): IMSId {
    this.logger.log(this.constructor.name, 'loadObjIdForTargetRef', targetRef);
    const clientState = this.clientStateService.theState.getValue();
    switch (targetRef) {
      case 'ims/Employee':
        return this.employeeService.me$.getValue()?.id;
      case 'ims/DeficiencyTicket':
        return clientState?.deficiencyTicketId;
      case 'ims/ServiceJob':
      default:
        return clientState?.serviceJobId;
    }
  }
}
